export interface BalanceType {
  amount: number;
  bonus: number;
  currency: string;
  currencySymbol: string;
  currencySymbolBefore: boolean;
  updateTimestamp: number;
}

export interface UserInfoType {
  casinoId: string;
  userId: string;
  userType: string;
  screenName: string;
  country: string;
  enrolmentDate: string;
  hasActiveBets: boolean;
  ranking: number | string;
  points: number | string;
  balance: BalanceType;
}

export enum UserInfoVersion {
  UI = 'ui',
  WALLET = 'wallet',
}

export interface IUserInfoResponseUI {
  balance: number | string;
  bonusBalance: number | string;
  casinoId: string;
  countryCode: string;
  currency: string;
  currencyCode: string;
  currencySymbolBefore: boolean;
  enrollmentDate: string;
  hasActiveBets: boolean;
  points: number | string;
  ranking: number | string;
  screenName: string;
  userId: string;
  userType: string;
  errorCode?: number;
  description?: string;
}

export interface IUserInfoResponseWALLET {
  balance: number;
  blockSafebets: false;
  bonusBalance: number;
  casinoId: string;
  countryCode: string;
  currency: string;
  currencyCode: string;
  currencySymbolBefore: boolean;
  currentPlaythrough: null;
  enrollmentDate: string;
  hasActiveBets: boolean;
  points: number;
  ranking: number;
  requiredPlaythrough: null;
  screenName: string;
  thirdpartySession: null;
  totalBalance: number;
  userId: string;
  userType: string;
  errorCode?: number;
  description?: string;
}
